/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

export enum TOC_TYPES {
  /**
   * Default
   */
  DEFAULT = '',

  /**
   * Horizontal variant
   */
  HORIZONTAL = 'horizontal',
}
